import { CardsInputBlock } from '@coast/schemas';
import { useMemo, useRef, useState } from 'react';
import { TextInput } from 'react-native';
import { View } from '@shared/components/View';
import { MBSearchBar } from '@shared/components/searchBar';
import { grid } from '@shared/styles';
import { LinkedCard } from '../../cards';
import { RelatedCardsList } from '../RelatedCardsList';

interface Props {
  block: CardsInputBlock;
  cards: LinkedCard[];
  onEditCards(): void;
  onShowMore?(): void;
  onRemoveCard?(card: LinkedCard): void;
  onPressCard?(card: LinkedCard): void;
}

export function ViewAllRelatedCards({
  block,
  cards,
  onEditCards,
  onRemoveCard,
  onPressCard,
}: Props) {
  const searchInputRef = useRef<TextInput>(null);
  const [searchTerm, setSearchTerm] = useState('');

  const cardsToRender = useMemo(() => {
    if (searchTerm) {
      return cards.filter(card => card.name?.toLowerCase().includes(searchTerm.toLowerCase()));
    } else {
      return cards;
    }
  }, [cards, searchTerm]);

  return (
    <View padding={2} fill>
      <MBSearchBar
        style={{ paddingLeft: grid(2), paddingBottom: grid(1) }}
        forwardRef={searchInputRef}
        value={searchTerm}
        onChangeText={setSearchTerm}
        returnKeyType="go"
        autoFocus={true}
      />
      <View flex>
        <RelatedCardsList
          totalCardsNubmer={cards.length}
          cards={cardsToRender}
          block={block}
          onEditCards={onEditCards}
          onPressCard={onPressCard}
          onRemoveCard={onRemoveCard}
        />
      </View>
    </View>
  );
}
